<script setup>
  //   import testimonial from '../../../public/images/welcome/computerLock.jpg';
  import testimonial from '../../../public/images/welcome/security.svg';
</script>

<template>
  <div class="overflow-hidden">
    <div class="relative mx-auto flex w-5/6 max-w-6xl flex-col text-center">
      <p class="z-50 w-full font-title text-3xl md:mb-4">
        <span class="homepage-text74">Enhanced Security</span>
        <span class="ml-1 font-semibold">Features</span>
      </p>
      <div class="w-5/6">
        <!-- <div
          class="absolute bottom-0 h-72 w-full bg-[#ffe6b9] md:-right-20 md:top-0 md:h-full md:w-[80%]"
        ></div> -->
      </div>
      <div class="mt-6 flex w-full flex-col md:flex-row">
        <div class="relative md:w-1/2">
          <div class="">
            <img
              :src="testimonial"
              alt="testimonials image"
              class="mx-auto w-2/3 md:ml-12"
            />
            <div
              class="absolute bottom-4 flex aspect-square h-16 w-16 items-center justify-center rounded-full bg-[#377ed69d] md:-top-4 md:right-2"
            >
              <i class="fas fa-shield-alt left text-[45px] text-black"></i>
            </div>
          </div>
        </div>
        <div class="z-50 p-4 md:-mt-6 md:w-1/2">
          <p class="text-base">
            At Spicy Collab, we prioritize your
            <span class="font-semibold">safety</span>
            and
            <span class="font-semibold">security</span>
            . To ensure a trustworthy and professional ​environment, we offer
            robust security measures for all members.
          </p>
          <p class="mt-2 mt-6 text-base">
            All members must undergo
            <span class="font-semibold">age verification</span>
            to join our platform, ensuring a
            <span class="font-semibold">safe</span>
            and
            <span class="font-semibold">appropriate community</span>
            for creative professionals.
          </p>

          <p class="mt-2 mt-6 text-base">
            For added security, we implement a two-factor authentication system.
            With these security features in place, you can confidently connect,
            collaborate, and grow your career on
            <span class="font-semibold">Spicy Collab</span>
            .
          </p>
        </div>
      </div>
      <!-- <div class="homepage-frame1261153619">
          <div class="homepage-frame2147223484">
            <div class="homepage-frame1261153614">
              <div class="homepage-frame1261153618">
                <span class="homepage-text76 TypographyBodyText">
                  “Spicy Collab has completely transformed the way I find and manage
                  opportunities. The ability to post gigs privately and connect with
                  other creators has opened up so many doors. The calendar feature
                  is a lifesaver—keeping everything organized in one place has been
                  a game-changer. What I love about Spicy Collab is the sense of
                  community. I can collaborate with other talented creators, find
                  gigs that align with my skills, and manage my schedule easily.
                  It’s the perfect platform for anyone looking to take their
                  creative career to the next level.”
                </span>
                <div class="homepage-frame2147223982">
                  <span class="homepage-text77 TypographyH4">
                    Ethan James Carter
                  </span>
                  <span class="homepage-text78 TypographyButtonText">
                    Content Creator
                  </span>
                </div>
              </div>
            </div>
            <div class="homepage-group1171275133">
              <div class="homepage-frame1000000988">
                <div class="homepage-group1000000985">
                  <img
                    src="/external/ellipse14525-zunw-200h.png"
                    alt="Ellipse14525"
                    class="homepage-ellipse11"
                  />
                  <img
                    src="/external/ionarrowup4525-k03.svg"
                    alt="ionarrowup4525"
                    class="homepage-ionarrowup1"
                  />
                </div>
                <div class="homepage-group1000000986">
                  <img
                    src="/external/ellipse14525-64xl-200h.png"
                    alt="Ellipse14525"
                    class="homepage-ellipse12"
                  />
                  <img
                    src="/external/ionarrowup4525-n75.svg"
                    alt="ionarrowup4525"
                    class="homepage-ionarrowup2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div> -->
    </div>
  </div>
</template>

<style scoped></style>
